import { Link } from 'react-router-dom';

import type { FC } from 'react';

export const NavigationColumn: FC = () => (
  <div className="NavigationColumn">
    <h4>Навигация</h4>
    <ul>
      <li>
        <Link to="https://byhelp.ru/price">Цены</Link>
      </li>
      <li>
        <Link to="https://byhelp.ru/#functions">Функционал</Link>
      </li>
      <li>
        <Link to="https://byhelp.ru/#reviews">Отзывы</Link>
      </li>
      <li>
        <Link to="https://byhelp.ru/#spheres">Для кого</Link>
      </li>
    </ul>
  </div>
);
